import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e5ba6de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"white !important","margin":"0 5px"} }, "|", -1 /* HOISTED */))
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "box_button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-github" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "box_other" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1 /* HOISTED */))
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuOutlined = _resolveComponent("MenuOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_GithubOutlined = _resolveComponent("GithubOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_Link = _resolveComponent("Link")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("nav", {
    ref: "nav",
    id: "nav",
    class: _normalizeClass(["nav", {active:_ctx.$Store.Public().scroll.y<=80||_ctx.$Store.Public().scroll.dY==='top'}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "logo",
        alt: "logo",
        src: $data.file.ImageLogo
      }, null, 8 /* PROPS */, _hoisted_2),
      (_ctx.$Store.Public().isGridMatch('<',_ctx.$Enum.GridEnum.XL))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "button_menu",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$Store.Page().updateMenu({isOpen:!_ctx.$Store.Page().menu.isOpen})))
          }, [
            _createVNode(_component_MenuOutlined, {
              class: _normalizeClass(!_ctx.$Store.Page().menu.isOpen?'active':'')
            }, null, 8 /* PROPS */, ["class"]),
            _createVNode(_component_CloseOutlined, {
              class: _normalizeClass(_ctx.$Store.Page().menu.isOpen?'active':'')
            }, null, 8 /* PROPS */, ["class"])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["box_menu", _ctx.$Store.Page().menu.isOpen?'active':'']),
        style: _normalizeStyle({maxHeight:`${_ctx.$Store.Public().height-60}px`})
      }, [
        _createVNode(_component_a_row, { justify: "end" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              xl: 13
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu, {
                  mode: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'horizontal':'inline',
                  inlineIndent: 35,
                  subMenuCloseDelay: 0.3,
                  selectable: false
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$Store.Page().menu.list, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (item.icon)
                          ? (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: index,
                              style: {"width":"32px"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  class: _normalizeClass({point:item.point})
                                }, [
                                  _createVNode(_component_GithubOutlined, {
                                    style: {"fontSize":"18px"},
                                    onClick: ($event: any) => ($options.localTo(item.href))
                                  }, null, 8 /* PROPS */, ["onClick"]),
                                  _hoisted_3
                                ], 2 /* CLASS */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */))
                          : (item.children!==undefined)
                            ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                                key: `${index}_sub`,
                                disabled: item.children.length===0
                              }, {
                                title: _withCtx(() => [
                                  _createElementVNode("a", {
                                    class: _normalizeClass({point:item.point})
                                  }, _toDisplayString(item.name), 3 /* TEXT, CLASS */)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (v, i) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      (v.children!==undefined)
                                        ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                                            key: `${index}_${i}_sub`,
                                            disabled: v.children.length===0
                                          }, {
                                            title: _withCtx(() => [
                                              _createElementVNode("a", null, _toDisplayString(v.name), 1 /* TEXT */)
                                            ]),
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.children, (vv, ii) => {
                                                return (_openBlock(), _createBlock(_component_a_menu_item, {
                                                  key: `${index}_${i}_${ii}`
                                                }, {
                                                  default: _withCtx(() => [
                                                    (vv.type===$data.enumType.menu.Doc)
                                                      ? (_openBlock(), _createElementBlock("a", {
                                                          key: 0,
                                                          target: "_blank",
                                                          href: vv.href
                                                        }, [
                                                          _createElementVNode("i", {
                                                            class: _normalizeClass(["iconfont", `icon-${vv.name.toLowerCase()}`])
                                                          }, null, 2 /* CLASS */),
                                                          _createTextVNode(" " + _toDisplayString(vv.name) + " ", 1 /* TEXT */),
                                                          _createVNode(_component_CaretRightOutlined)
                                                        ], 8 /* PROPS */, _hoisted_4))
                                                      : (vv.type===$data.enumType.menu.Book)
                                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                                            key: 1,
                                                            to: vv.href,
                                                            target: "_blank"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(vv.name) + " ", 1 /* TEXT */),
                                                              _createVNode(_component_CaretRightOutlined)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                                                        : (_openBlock(), _createElementBlock("a", {
                                                            key: 2,
                                                            target: "_blank",
                                                            href: vv.href
                                                          }, [
                                                            _createTextVNode(_toDisplayString(vv.name) + " ", 1 /* TEXT */),
                                                            _createCommentVNode("   <CaretRightOutlined /> ")
                                                          ], 8 /* PROPS */, _hoisted_5))
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */))
                                              }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled"]))
                                        : (_openBlock(), _createBlock(_component_a_menu_item, {
                                            key: `${index}_${i}`
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Link, {
                                                name: v.name,
                                                point: v.point,
                                                href: v.href+(v.hash?`#${v.hash}`:''),
                                                click: v.click
                                              }, null, 8 /* PROPS */, ["name", "point", "href", "click"])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */))
                                    ], 64 /* STABLE_FRAGMENT */))
                                  }), 256 /* UNKEYED_FRAGMENT */))
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled"]))
                            : (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: index.toString(),
                                disabled: item.href===undefined&&item.click===undefined
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Link, {
                                    class: _normalizeClass({point:item.point}),
                                    name: item.name,
                                    icon: item.icon,
                                    href: item.href,
                                    click: item.click
                                  }, null, 8 /* PROPS */, ["class", "name", "icon", "href", "click"])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled"]))
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["mode"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              xl: 3
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    target: "_blank",
                    href: $data.href.github
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createTextVNode(" GitHub ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["href"]),
                  _createCommentVNode("<a-dropdown placement=\"bottomRight\" overlayClassName=\"box_dropdown\""),
                  _createCommentVNode("            :getPopupContainer=\"()=>$refs.nav\">"),
                  _createCommentVNode("  <template #overlay>"),
                  _createCommentVNode("    <a-menu>"),
                  _createCommentVNode("      <a-menu-item>"),
                  _createCommentVNode("        <a :href=\"`${$Config.Href.cloudDemo}/projects/project/113244017852022788`\">"),
                  _createCommentVNode("          应用托管平台"),
                  _createCommentVNode("        </a>"),
                  _createCommentVNode("      </a-menu-item>"),
                  _createCommentVNode("      <a-menu-item>"),
                  _createCommentVNode("        <a @click=\"$RQ.GoGSS()\">"),
                  _createCommentVNode("          智能运维平台"),
                  _createCommentVNode("        </a>"),
                  _createCommentVNode("      </a-menu-item>"),
                  _createCommentVNode("    </a-menu>"),
                  _createCommentVNode("  </template>"),
                  _createCommentVNode("  <a-button type=\"link\">"),
                  _createCommentVNode("    体验Demo"),
                  _createCommentVNode("  </a-button>"),
                  _createCommentVNode("</a-dropdown>"),
                  _createCommentVNode("<a-button type=\"primary\" target=\"_blank\""),
                  _createCommentVNode("          :href=\"href.gitee\">"),
                  _createCommentVNode("    <span class=\"iconfont icon-gitee\" />"),
                  _createCommentVNode("    Gitee"),
                  _createCommentVNode("</a-button>")
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              xl: 5
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_dropdown, {
                    placement: "bottomRight",
                    overlayClassName: "box_dropdown",
                    getPopupContainer: ()=>_ctx.$refs.nav
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$Enum.LanguageDict, (item) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.$Store.Overseas().setLanguage(item.value))
                                }, _toDisplayString(item.label), 9 /* TEXT, PROPS */, _hoisted_9)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        class: "button_language",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$Enum.LanguageDict.find(v => v.value === _ctx.$Enum.LanguageEnum.ZH).label) + " ", 1 /* TEXT */),
                          _createVNode(_component_DownOutlined)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getPopupContainer"]),
                  _hoisted_10,
                  (!_ctx.$RQ.SSO.check())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_button, {
                          type: "link",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$RQ.SSO.login()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 注册 ")
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _hoisted_11,
                        _createVNode(_component_a_button, {
                          type: "link",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$RQ.SSO.login()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 登录 ")
                          ]),
                          _: 1 /* STABLE */
                        })
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createBlock(_component_a_dropdown, {
                        key: 1,
                        placement: "bottomRight",
                        overlayClassName: "box_dropdown",
                        getPopupContainer: ()=>_ctx.$refs.nav
                      }, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    target: "_blank",
                                    href: _ctx.$Config.Href.store
                                  }, " AI应用市场 ", 8 /* PROPS */, _hoisted_12)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createCommentVNode(" <a-menu-item>\n                        <a target=\"_blank\"\n                           :href=\"$Config.Href.cloud\">\n                          AI应用托管\n                        </a>\n                      </a-menu-item>"),
                              _createCommentVNode("<a-menu-item>"),
                              _createCommentVNode("  <a target=\"_blank\""),
                              _createCommentVNode("     :href=\"$Config.Href.dtexpress\">"),
                              _createCommentVNode("    数据物流"),
                              _createCommentVNode("  </a>"),
                              _createCommentVNode("</a-menu-item>"),
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.logout && $options.logout(...args)))
                                  }, " 退出登录 ")
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "link",
                            class: "box_info",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$Store.User().username), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getPopupContainer"]))
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ], 6 /* CLASS, STYLE */)
    ])
  ], 2 /* CLASS */))
}